import { useContext, useEffect } from 'react';
import '../style/pages/product.css';
import { CurrentTime } from '../funcs/current'; 
import ProductTable from '../components/productTable';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { recodeNow, mainSearch, update} from '../components/indexDB/indexDBStora';
import { config } from '../context/config';
import { action } from '../context/action';
import { dataa } from '../context/data';
import { switchh } from '../context/switch';
import { collection } from '../context/collect';
import { intialData } from '../context/initial';
import { MakeAsync } from '../funcs/MakeAsync';
import { useTranslation } from 'react-i18next';
import { ValidatioProduct } from '../funcs/validation/validationProduct';
export default function Product () {
    const { t } = useTranslation();
    const { stylingNav } = useContext(config);
    const { category } = useContext(dataa);
    const {setLoadingProcess} = useContext(switchh);
    const {setErrorMessage, errorMessage ,editMode, setEditMode} = useContext(action);
    const { newProduct, setNewProduct } = useContext(collection);
    const { initialProductState } = useContext(intialData);
    
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const getSearch = async (signal) => {
        try {
            const getProduct = await mainSearch("products", id);
            // if not found the product prevent continue
            if(!getProduct || signal.aborted) {
                navigate('/products');
                setEditMode(false);
                return;
            };
            setNewProduct((prev) => ({
                ...prev,
                id: getProduct.id,
                nameProudct: getProduct.nameProudct,
                brand: getProduct.brand,
                sku: getProduct.sku,
                inventoryId: getProduct.inventoryId,
                meta: {
                    ...prev.meta,
                    barcode: getProduct.meta.barcode,
                    createdAt: getProduct.meta.createdAt
                },
                sellPrice: getProduct.sellPrice,
                categoryId: getProduct.categoryId,
                tax: {taxType: getProduct.tax.taxType, taxValue: getProduct.tax.taxValue},
            }));
        }
        catch(err) {
            console.error("Search error:", err);
        }
    }

    useEffect(() => {
        if (!id || location.pathname === "/products") return;

        const isScan = location.pathname.includes("scan");
        const controller = new AbortController();

        if (isScan) {
            setEditMode(false);
            navigate("/products");
            return;
        }

        setEditMode(true);
        getSearch(controller.signal);

        return () => {
            controller.abort();
        }

    }, [id, location.pathname, navigate]);

    // new product   
    const recordNewProduct = async (e) => {
        e.preventDefault();
        try {
            setLoadingProcess(true)
            const result = await ValidatioProduct(newProduct);
            if(!result.status) {
                setErrorMessage(result.message);
                return;
            }
            setErrorMessage("");
            await recodeNow(newProduct, "products");
            setNewProduct(initialProductState());
            setErrorMessage("");
        }
        catch(err) {
            throw new Error(`err => ${err}`);
        }
        finally {
            setLoadingProcess(false);
        }
    }

    // add constant tax
    useEffect(() => {
        if (newProduct.tax.taxType === "fixed") {
            setNewProduct((prev) => ({
                ...prev,
                tax: {
                    ...prev.tax,
                    taxValue: 14
                }
            }));
        }
    }, [
    newProduct.tax.taxValue,
    newProduct.tax.taxType,
    ]);

    const updateProudct = async () => {
        try {
            setLoadingProcess(true);
            const updatedProduct = MakeAsync(newProduct, "update");
            if (!updatedProduct) {
                console.warn("Invalid update state");
                return;
            }

            // set current update time
            updatedProduct.meta.updateDate = CurrentTime();
            // convert discount value to Number

            await update("products", updatedProduct);

            setNewProduct(initialProductState);
            setEditMode(false);
            navigate("/products");
        } catch (err) {
            console.log(err);
        } finally {
            setLoadingProcess(false);
        }
    };
    return (
        <div className={`product page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            <h2 className='text-weight-light'>{t("sections:products.full")}</h2>
            <div className='record-product'>
                <form onSubmit={recordNewProduct}>
                    <div className='important-infos sec flex'>
                        <div className='ch'>
                            <label>{t("common:id")}</label>
                            <input className='disabled inp' readOnly type='text' value={newProduct.taker.emp.id + " - " + newProduct.taker.emp.name} 
                            placeholder={t("placeholder:product.id")}/>
                        </div>
                        <div className='ch'>
                            <label>{t("label:product.storeName")}</label>
                            <input className='disabled inp' readOnly type='text' value={newProduct.idStore} placeholder={t("placeholder:product.storeName")}/>
                        </div>
                    </div>
                    <div className='general-info sec flex'>
                        <div className='ch'>
                            <label className='imp'>{t("label:product.barcode")}</label>
                            <input
                            disabled={editMode}
                            onChange={(e) => {
                                const value = e.target.value;
                                const onlyNumbers = value.replace(/[^0-9]/g, "");
                                setNewProduct((prev) => ({
                                    ...prev,
                                    meta: { 
                                        ...prev.meta, 
                                        barcode: onlyNumbers 
                                    }
                                }));
                            }}
                            className='inp'
                            value={newProduct.meta.barcode}
                            maxLength={80} autoFocus type='text' placeholder={t("placeholder:product.barcode")}/>
                        </div>
                        <div className='ch'>
                            <label className='imp'>{t("label:product.productName")}</label>
                            <input
                            className='inp'
                            onChange={(e) => setNewProduct((prev) => ({...prev, nameProudct: e.target.value }))}
                            value={newProduct.nameProudct}
                            type='text' maxLength={70} placeholder={t("placeholder:product.productName")}/>
                        </div>
                    </div>
                    <div className='sku-tax sec flex'>
                        <div className='ch'>
                            <label className='imp'>sku</label>
                            <input
                                className='inp'
                                maxLength={14}
                                type='text' 
                                value={newProduct.sku}
                                onChange={(e) => {
                                    let value2 = e.target.value;
                                    value2 = value2.replace(/-/g, '');
                                    let formatted = '';
                                    for (let i = 0; i < value2.length; i++) {
                                        if (i > 0 && i % 3 === 0) {
                                            formatted += '-';
                                        }
                                        formatted += value2[i];
                                    }
                                    setNewProduct((prev) => ({...prev, sku: formatted.toUpperCase()}));
                                }}
                            />
                            <small className='warning'>{t("common:noteSKU")}</small>
                        </div>
                        <div className='ch'>
                            <div className='tax flex'>
                                <div className='ch'>
                                    <label className='imp'>{t("label:product.tax.label")}</label>
                                    <input
                                    className='ign-line inp' 
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const numberOnly = value.replace(/[^0-9]/g, "");
                                        setNewProduct((prev) => ({
                                            ...prev,
                                            tax: {
                                                ...prev.tax,
                                                taxValue: numberOnly
                                            }
                                        }));
                                    }}
                                    placeholder={t("placeholder:product.tax")}
                                    value={newProduct.tax.taxType === "fixed" ? "14" : newProduct.tax.taxValue} type='text' />
                                </div>
                                <div className='ch'>
                                    <select value={newProduct.tax.taxType} onChange={(e) => setNewProduct((prev) => ({...prev, tax: {...prev.tax, taxType: e.target.value}}))}>
                                        <option disabled value={''}>{t("label:product.tax.taxType")}</option>
                                        <option value={'fixed'}>{t("label:product.tax.constant")}</option>
                                        <option value={'different'}>{t("label:product.tax.changing")}</option>
                                    </select>
                                </div>
                            </div>
                            <small className='warning'>{t("common:TaxIsPercentage")} (%)</small>
                        </div>
                    </div>
                    <div className='sec flex'>
                        <div className='ch'>
                            <label className='imp'>{t("label:product.category.label")}</label>
                            <select
                                value={newProduct.categoryId || ''}
                                onChange={(e) => {
                                    const selected = category.find(cat => cat.id === e.target.value);
                                    setNewProduct(prev => ({
                                        ...prev,
                                        categoryId: selected.id
                                    }));
                                }}
                            >
                                <option value='' disabled>{t("label:product.category.chooseCat")}</option>
                                {category && category.map((cat, i) =>
                                    <option key={i} value={cat.id}>{cat.name}</option>
                                )}
                            </select>
                        </div>
                        <div className='ch'>
                            <label>{t("label:product.brand")}</label>
                            <input 
                                className='inp'
                                value={newProduct.brand} 
                                onChange={(e) => setNewProduct((prev) => ({...prev, brand: e.target.value}))} 
                                type='text' placeholder={t("placeholder:product.brand")} />
                        </div>
                    </div>
                    <div className='sec flex'>
                        <div className='ch'>
                            <label className='imp'>
                                {t("label:product.pricing")}
                            </label>
                            <input
                                className='inp'
                                type='number'
                                value={newProduct.sellPrice}
                                placeholder={t("label:product.pricing")}
                                onChange={(e) =>
                                    setNewProduct(prev => ({
                                        ...prev,
                                        sellPrice: Number(e.target.value)
                                    }))
                                }
                            />
                        </div>
                        <div className='ch flex'>
                            <div className='ch'>
                                <label>{t("label:product.discount.label")}</label>
                                <input
                                    className='inp'
                                    type='number'
                                    value={newProduct.discount.discountValue}
                                    onChange={(e) =>
                                        setNewProduct(prev => ({
                                            ...prev,
                                            discount: {
                                                ...prev.discount,
                                                discountValue: Number(e.target.value)
                                            }
                                        }))
                                    }
                                />
                            </div>
                            <div className='ch'>
                                <label>{t("label:product.discount.discountType")}</label>
                                <select
                                    value={newProduct.discount.discountType}
                                    onChange={(e) =>
                                        setNewProduct(prev => ({
                                            ...prev,
                                            discount: {
                                                ...prev.discount,
                                                discountType: e.target.value
                                            }
                                        }))
                                    }
                                >
                                    <option value="fixed">
                                        {t("label:product.discount.pound")}
                                    </option>
                                    <option value="percent">
                                        {t("label:product.discount.percentage")}
                                    </option>
                                </select>
                            </div>

                        </div>
                    </div>
                    <div className='sec'>
                        <div className='ch'>
                            <label className='imp'>النوع</label>
                            <select value={newProduct.type} disabled={editMode} onChange={(e) => setNewProduct((prev) => ({...prev, type: e.target.value}))}>
                                <option value={'weight'}>بالوزن</option>
                                <option value={'unit'}>وحده</option>
                            </select>
                        </div>
                    </div>
                    <p className='error'>{errorMessage}</p>
                    <div className='action'>
                        {editMode ? 
                        <>
                            <button type='button' onClick={updateProudct}>{t("action:product.edit")}</button>
                            <button onClick={() => {
                                setEditMode(false);
                                navigate("/products");
                                setNewProduct(initialProductState);
                            }}>x</button>
                        </>
                        :
                        <button onClick={() => {
                            const newTime = CurrentTime();
                            setNewProduct((prev) => ({...prev, meta: {...prev.meta, createdAt: newTime}}));
                        }}>{t("action:product.NewRecord")}</button>
                        }
                    </div>
                </form>
            </div>
            <h2 className='text-weight-light'>{t("section:products")}</h2>
            <div className='display-products'>
                <ProductTable />
            </div>
            <Outlet />
        </div>
    )
}